import {
  CANCEL_ATA_SUCCESS,
  CREATE_SPARE_RECEIPT_ADVISE_SUCCESS,
  FETCH_ASSET_LIST_BY_STA,
  FETCH_OPEN_STA_SUCCESS,
  FETCH_SPARE_RECEIPT_ADVISE_SUCCESS,
  FETCH_SRA_NO_SUCCESS,
  GET_SPARE_RECEIPT_ADVISE_SUCCESS,
  SAVE_SPARE_RECEIPT_ADVISE_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  sptListBySta: [],
  sraNo: 0,
  openSta: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SPARE_RECEIPT_ADVISE_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_SPARE_RECEIPT_ADVISE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_SPARE_RECEIPT_ADVISE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_SPARE_RECEIPT_ADVISE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_ASSET_LIST_BY_STA: {
      return {
        ...state,
        sptListBySta: action.data,
      };
    }

    case FETCH_SRA_NO_SUCCESS : {
      return {
        ...state,
        sraNo: action.data,
      };
    }

    case CANCEL_ATA_SUCCESS : {
      return {
        ...state,
      };
    }

    case FETCH_OPEN_STA_SUCCESS: {
      return {
        ...state,
        openSta: action.data,
      }
    }

    default:
      return state;
  }
}
